import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-profile-setup',
  templateUrl: './tutorial-profile-setup.component.html',
  styleUrls: ['./tutorial-profile-setup.component.css']
})
export class TutorialProfileSetupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
